// extracted by mini-css-extract-plugin
module.exports = {"fullCapacity":"styles-module__fullCapacity___2mV4S","lowCapacity":"styles-module__lowCapacity___2wrLU","blink-animation":"styles-module__blink-animation___3INCS"};